import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom"; 
import { getPrincipalMessage } from "../Service/Api";
import LazyLoad from "react-lazyload";
import Header from'../Component/Header'
const DirectorMessage = () => {
  useEffect(() => {
    document.title =
      "Our Principal - St. Josephs School Quadian Punjab";
  }, []);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); 
  useEffect(() => {
    const fetchData = async () => {
      try {
        const principalData1 = await getPrincipalMessage();
        const principalData = principalData1.filter((item) => item.category === 'Director');
        
        setData(principalData);
      } catch (error) {
        console.log("Data Error", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []); 
  return (
    <> 
    <Header/>
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link> 
          </li>

          <li> Director's Message</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2>  Director's Message </h2>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              {data.length > 0  && (
                    <div className="clearfix">
                      <LazyLoad
                        offset={10}
                        placeholder={
                          <img
                            src="https://webapi.entab.info/api/image/SJCSQP/public/Images/dummy.jpg"
                            alt="Loading..."
                            className="img-fluid"
                          />
                        }>
                        <img
                          src={`https://webapi.entab.info/api/image/${data[0].attachments}`}
                          alt=""
                          className="col-md-4 float-md-end  left-img img-fluid"
                        />
                      </LazyLoad>

                        
                          <div className="innermsg" dangerouslySetInnerHTML={{ __html: data[0].message }} />
                        
                      <div className="mesdeskimg">
                        <h3> {data[0].name}</h3>
                        <h5> {data[0].category}</h5>
                      </div>
                    </div>
                  )} 
                  {data.length === 0  && (
                    <div className="clearfix">
                      <img
                        src="https://webapi.entab.info/api/image/SJCSQP/public/Images/dummy.jpg"
                        className="col-md-4 float-md-end left-img img-fluid"
                      />
 
                       <p>Message</p>   
                      <div className="mesdeskimg">
                        
                        <h3>  Name</h3> <h5> Director </h5>
                      </div>
                    </div>
                  )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DirectorMessage;
